

























































































































import { Emit, Inject, Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { FILE_USER_FORS, MAP_TYPES } from '@/constants';
import FileGeodeticService from '@/entities/file-geodetic/file-geodetic.service';
import { IFileGeodetic } from '@/shared/model/file-geodetic.model';
import { FileGeodeticMapType } from '@/shared/model/enumerations/file-geodetic-map-type.model';
import FileTextBoxSearch from '@/custom/page/common/FileTextBoxSearch.vue';
import Map2dService from '@/entities/map-2-d/map-2-d.service';
import ProjectTextBoxSearch from '@/custom/page/common/ProjectTextBoxSearch.vue';
import Vr360Service from '@/entities/vr-360/vr-360.service';
import Model3dService from '@/entities/model-3-d/model-3-d.service';
import { FilePurpose } from '@/shared/model/enumerations/file-purpose.model';
import { IMap2d } from '@/shared/model/map-2-d.model';
import PlanningService from '@/entities/planning/planning.service';
import { IPlanning } from '@/shared/model/planning.model';

@Component({
  components: { ProjectTextBoxSearch, FileTextBoxSearch },
})
export default class ImportFilePage extends Vue {
  @Inject() projectsFn;
  @Inject() filesFn;
  @Inject() uploadProgressFn;
  @Inject() aggregateUploadProgressFn;

  // get projects() {
  //   return this.projectsFn().projects;
  // }

  projects = [];
  uploadInfos = [];
  selectedUseFor: string = FILE_USER_FORS[2].id;
  selectedMap = MAP_TYPES[0].id;
  entity: IFileGeodetic = {
    name: '',
    project: { id: null },
    filePurpose: FilePurpose.GEODETIC,
  };
  planningEntity: IPlanning = {
    name: '',
    project: { id: null },
  };
  files: any[] = null;
  dxfFile: any = null;
  singleFile = null;
  selectExistFile = false;
  loading = false;
  loadingMaps = false;
  map2dsForProject: IMap2d[] = [];
  selectedMap2dIdForPlanning = null;
  flightDate = new Date().toISOString().substring(0, 10);
  flightDateMenu = false;
  fileSearchData = {
    selectFile: null,
  };

  get fileUseFors() {
    return FILE_USER_FORS;
  }

  get selectMapTypePurpose() {
    return this.selectedUseFor === this.fileUseFors[2].id;
  }

  get selectPlanningTypePurpose() {
    return this.selectedUseFor === this.fileUseFors[3].id;
  }

  get selectVideoTypePurpose() {
    return this.selectedUseFor === this.fileUseFors[1].id;
  }

  get acceptFileType() {
    let imgType = 'image/png, image/jpeg, image/jpg';
    let videoType = 'video/mp4, .mkv, .mov';
    if (this.selectedUseFor === FILE_USER_FORS[0].id) {
      return imgType;
    } else if (this.selectedUseFor === FILE_USER_FORS[1].id) {
      return videoType;
    } else if (this.selectedUseFor === FILE_USER_FORS[2].id) {
      if (this.selectedMap === 'MAP_2D') {
        return 'image/tiff';
      } else if (this.selectedMap === 'MODEL_3D') {
        return '.las';
      } else if (this.selectedMap === 'VR360') {
        return imgType;
      }
    } else if (this.selectedUseFor === FILE_USER_FORS[3].id) {
      return '.dxf';
    }
  }

  get mapTypes() {
    return MAP_TYPES.filter(t => t.id !== 'PLANNING');
  }

  @Watch('entity.project.id')
  onProjectIdChange(newVal) {
    if (newVal) {
      this.fetchMap2dsForProject(newVal);
    } else {
      this.map2dsForProject = [];
      this.selectedMap2dIdForPlanning = null;
    }
  }

  fetchProjects() {}

  mounted() {
    this.selectedUseFor = FILE_USER_FORS[2].id;
    this.selectedMap = this.mapTypes[0].id;
    this.entity.project.id = this.$route.params.projectId ? parseInt(this.$route.params.projectId) : null;
    if (this.entity.project.id) {
      this.fetchMap2dsForProject(this.entity.project.id);
      this.planningEntity.project.id = this.entity.project.id;
    }
  }

  @Emit('updateMenuSelect')
  updateMenuSelect(val) {
    return val;
  }

  @Watch('fileSearchData.selectFile')
  onFileSearchDataSelectFileChange(val, oldVal) {
    this.files = [val];
  }

  @Watch('singleFile')
  onSingleFileChange(val, oldVal) {
    this.files = [val];
  }

  reloadToProjectDetailList() {
    // this.updateMenuSelect(3);
    // this.filesFn().reload();
    this.$router.push({ name: 'ProjectFilesDetailFileList', params: { projectId: this.entity.project.id } });
  }

  async fetchMap2dsForProject(projectId: number) {
    this.loadingMaps = true;
    try {
      const map2dService = new Map2dService();
      const res = await map2dService.filter(null, { projectId: projectId });
      this.map2dsForProject = res.data;
    } catch (e) {
      this.map2dsForProject = [];
      (this.$root as any).$bvToast.toast('Không thể tải danh sách bản đồ 2D.', {
        toaster: 'b-toaster-top-center',
        title: 'Lỗi',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    } finally {
      this.loadingMaps = false;
    }
  }

  async upload(onDone) {
    if (!this.files || !this.entity.project.id) {
      (this.$root as any).$bvToast.toast('Vui lòng điền đủ thông tin trước khi upload', {
        toaster: 'b-toaster-top-center',
        title: 'Chú ý',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
      return;
    }
    // console.log(this.files);
    this.loading = true;
    let fileGeodeticService = new FileGeodeticService();
    try {
      this.uploadInfos = this.files.map(file => ({ name: file.name, progress: 0 }));
      let key = Date.now() + '';
      this.uploadProgressFn().listComposeObject[key] = this.uploadInfos;
      this.aggregateUploadProgressFn();
      const onUploadProgress = (progressEvent, idx) => {
        let uploadInfo = this.uploadInfos[idx];
        let percentComplete = progressEvent.loaded / progressEvent.total;
        percentComplete = parseInt(String(percentComplete * 1000)) / 10.0;
        uploadInfo.progress = percentComplete;
      };

      this.entity.filePurpose = FilePurpose[this.selectedUseFor];
      this.entity.flightDate = new Date(this.flightDate);
      let rss = await Promise.all(
        this.files.map((file, idx) => fileGeodeticService.createAndUpload(this.entity, file, event => onUploadProgress(event, idx)))
      );
      // let fileGeodetic = await fileGeodeticService.createAndUpload(this.entity, this.file);
      (this.$root as any).$bvToast.toast(`Upload thành công ${this.files.length} files`, {
        toaster: 'b-toaster-top-center',
        title: 'Success',
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
      });
      this.uploadInfos = [];
      delete this.uploadProgressFn().listComposeObject[key];
      this.aggregateUploadProgressFn();
      if (typeof onDone === 'function') {
        await Promise.all(rss.map(rs => onDone(rs)));
      }
      this.reloadToProjectDetailList();
    } catch (e) {
      (this.$root as any).$bvToast.toast('Đã có lỗi xảy ra: ' + e, {
        toaster: 'b-toaster-top-center',
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    } finally {
      this.loading = false;
    }
  }

  async createPlanning() {
    if (!this.dxfFile) {
      (this.$root as any).$bvToast.toast('Vui lòng chọn file quy hoạch.', {
        toaster: 'b-toaster-top-center',
        title: 'Chú ý',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
      return;
    }
    this.loading = true;
    const fileGeodeticService = new FileGeodeticService();
    const planningService = new PlanningService();
    try {
      // Step 1: Upload the file to get a FileGeodetic object.
      this.entity.filePurpose = FilePurpose.DRAWING;
      this.entity.name = this.dxfFile.name;
      const fileGeodetic = await fileGeodeticService.createAndUpload(this.entity, this.dxfFile, null);

      (this.$root as any).$bvToast.toast(`Upload file thành công. Đang tạo quy hoạch...`, {
        toaster: 'b-toaster-top-center',
        title: 'Info',
        variant: 'info',
        solid: true,
        autoHideDelay: 5000,
      });

      // Step 2: Call planningService.create with the required objects.
      const planningPayload: IPlanning = {
        name: this.planningEntity.name,
        project: { id: this.entity.project.id },
        fileGeodetic: { id: fileGeodetic.id },
      };

      await planningService.create(planningPayload);

      (this.$root as any).$bvToast.toast(`Tạo quy hoạch thành công!`, {
        toaster: 'b-toaster-top-center',
        title: 'Success',
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
      });

      this.reloadToProjectDetailList();
    } catch (e) {
      (this.$root as any).$bvToast.toast('Đã có lỗi xảy ra: ' + e, {
        toaster: 'b-toaster-top-center',
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    } finally {
      this.loading = false;
    }
  }

  async createMapView() {
    const vm = this;
    if (this.selectedMap === FileGeodeticMapType.MAP_2D) {
      let map2dService = new Map2dService();
      if (!this.selectExistFile) {
        const fileGeodeticIds = [];
        await this.upload(async fileGeodetic => {
          let id = await this.create2DMapView(map2dService, fileGeodetic, vm);
          if (id) fileGeodeticIds.push(id);
        });

        // if (fileGeodeticIds.length > 1) {
        //   await this.joinMap2ds(fileGeodeticIds, map2dService);
        //   this.reloadToProjectDetailList();
        // }
      } else {
        await this.create2DMapView(map2dService, this.fileSearchData.selectFile, vm);
        this.reloadToProjectDetailList();
      }
    } else if (this.selectedMap === FileGeodeticMapType.VR360) {
      let vr360Service = new Vr360Service();
      if (!this.selectExistFile) {
        await this.upload(async fileGeodetic => {
          await this.createVR360MapView(vr360Service, fileGeodetic, vm);
        });
      } else {
        await this.createVR360MapView(vr360Service, this.fileSearchData.selectFile, vm);
        this.reloadToProjectDetailList();
      }
    } else if (this.selectedMap === FileGeodeticMapType.MODEL_3D) {
      let model3dService = new Model3dService();
      if (!this.selectExistFile) {
        await this.upload(async fileGeodetic => {
          await this.createModel3dMapView(model3dService, fileGeodetic, vm);
        });
      } else {
        await this.createModel3dMapView(model3dService, this.fileSearchData.selectFile, vm);
        this.reloadToProjectDetailList();
      }
    }
  }

  private async joinMap2ds(fileGeodeticIds: any[], map2dService: Map2dService) {
    this.loading = true;
    try {
      let map2dJoined = await map2dService.join(fileGeodeticIds);
      (this.$root as any).$bvToast.toast(`Ghép thành công bản đồ 2D với id=${map2dJoined.id}`, {
        toaster: 'b-toaster-top-center',
        title: 'Success',
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
      });
    } catch (e) {
      (this.$root as any).$bvToast.toast('Đã có lỗi xảy ra: ' + e, {
        toaster: 'b-toaster-top-center',
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    } finally {
      this.loading = false;
    }
  }

  private async create2DMapView(map2dService: Map2dService, fileGeodetic, vm: this) {
    this.loading = true;
    let toastKey = 'creating2d_' + Date.now();
    // (this.$root as any).$bvToast.toast(`Đã lên lịch tạo dữ liệu bản đồ 2D. Dữ liệu sẽ sớm có...`, {
    //   id: toastKey,
    //   toaster: 'b-toaster-top-center',
    //   title: 'Đang tạo dữ liệu bản đồ',
    //   variant: 'info',
    //   solid: true,
    //   // noAutoHide: true,
    // });
    try {
      let rs = await map2dService.create({
        fileGeodetic: { id: fileGeodetic.id },
        project: { id: vm.entity.project.id },
        flightDate: fileGeodetic.flightDate || new Date(this.flightDate),
      });
      (this.$root as any).$bvToast.toast(`Đã lên lịch tạo dữ liệu bản đồ 2D. Dữ liệu sẽ sớm có...`, {
        id: toastKey,
        toaster: 'b-toaster-top-center',
        title: 'Đang tạo dữ liệu bản đồ',
        variant: 'info',
        solid: true,
        // noAutoHide: true,
      });
      // (this.$root as any).$bvToast.toast(`Tạo bản đồ 2D thành công, id=${rs.id}`, {
      //   toaster: 'b-toaster-top-center',
      //   title: 'Success',
      //   variant: 'success',
      //   solid: true,
      //   autoHideDelay: 5000,
      // });
      return rs.id;
    } catch (e) {
      (this.$root as any).$bvToast.toast('Đã có lỗi xảy ra: ' + e, {
        toaster: 'b-toaster-top-center',
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    } finally {
      (this.$root as any).$bvToast.hide(toastKey);
      this.loading = false;
    }
  }

  private async createVR360MapView(vr360Service: Vr360Service, fileGeodetic, vm: this) {
    this.loading = true;
    try {
      let rs = await vr360Service.create({
        largeImage: { id: fileGeodetic.id },
        project: { id: vm.entity.project.id },
        flightDate: fileGeodetic.flightDate || new Date(this.flightDate),
      });

      (this.$root as any).$bvToast.toast(`Tạo ảnh VR360 thành công, id=${rs.id}`, {
        toaster: 'b-toaster-top-center',
        title: 'Success',
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
      });
    } catch (e) {
      (this.$root as any).$bvToast.toast('Đã có lỗi xảy ra: ' + e, {
        toaster: 'b-toaster-top-center',
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    } finally {
      this.loading = false;
    }
  }

  private async createModel3dMapView(model3dService: Model3dService, fileGeodetic, vm: this) {
    this.loading = true;
    let toastKey = 'creating3d_' + Date.now();
    // (this.$root as any).$bvToast.toast(`Đã lên lịch tạo dữ liệu model 3D.`, {
    //   id: toastKey,
    //   toaster: 'b-toaster-top-center',
    //   title: '3D Model',
    //   variant: 'info',
    //   solid: true,
    //   noAutoHide: true,
    // });
    try {
      let rs = await model3dService.create({
        lasFile: { id: fileGeodetic.id },
        project: { id: vm.entity.project.id },
        flightDate: fileGeodetic.flightDate || new Date(this.flightDate),
      });

      (this.$root as any).$bvToast.toast(`Đã lên lịch tạo dữ liệu model 3D.`, {
        id: toastKey,
        toaster: 'b-toaster-top-center',
        title: '3D Model',
        variant: 'info',
        solid: true,
        // noAutoHide: true,
      });
    } catch (e) {
      (this.$root as any).$bvToast.toast('Đã có lỗi xảy ra: ' + e, {
        toaster: 'b-toaster-top-center',
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    } finally {
      (this.$root as any).$bvToast.hide(toastKey);
      this.loading = false;
    }
  }
}
